import { useAuth } from '@/hooks/use-auth';
import { useCurrentUserProfile } from '@/hooks/use-profile';

/**
 * Returns true if the current session is operating in demo mode.
 *
 * Checks two independent sources so the banner is robust regardless of
 * which one carries the flag first after login:
 *   1. The Better Auth session user (populated from the JWT's is_demo claim).
 *   2. The gateway profile response (populated from the D1 users.is_demo column).
 */
export function useIsDemoMode(): boolean {
  const { user } = useAuth();
  const { data: profileData } = useCurrentUserProfile();

  const authIsDemo = user?.isDemo === true;
  const profileIsDemo = profileData?.user?.isDemo === true;

  return authIsDemo || profileIsDemo;
}
